import * as CONSTANTS from 'config/constants';
import { parseJwt } from 'helpers';
import { Forbidden } from 'modules';
import { Navigate, Outlet } from 'react-router';

interface Props {
  isLoggedIn: boolean;
  redirectPath?: string;
  children: any;
  roles?: string[];
}

const PrivateRoute = ({
  isLoggedIn,
  redirectPath = '/login',
  children,
  roles = [],
}: Props) => {
  const token = localStorage.getItem(CONSTANTS.ACCESS_TOKEN);
  const tokenPayload = token ? parseJwt(token) : null;
  if (!isLoggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  if (roles && roles.length > 0) {
    if (!roles.includes(tokenPayload?.data?.admin_role)) {
      return <Forbidden />;
    }
  }

  return <>{children ? children : <Outlet />}</>;
};

export default PrivateRoute;
